import { ref } from 'vue'
import { defineStore } from 'pinia'
import { myAlarmList} from '@/api/alarm';
export const useMyAlarmStore = defineStore(
    'myalarm',
    () => {
        const NotReadMyAlarm = ref(false);
        const NotReadMyAlarmCount = ref(0);
        async function myAlarmListData(){
            const res = await myAlarmList()
            if(res.rtn && res.rtn.length > 0){
              NotReadMyAlarm.value =  res.rtn.some((data)=>{
                    return data.read_yn === 'N'
                })
                NotReadMyAlarmCount.value = res.rtn.filter((data)=>{
                    return data.read_yn === 'N'
                }).length
            }
            return res
        }

        return {NotReadMyAlarm, myAlarmListData ,NotReadMyAlarmCount}
    },
    {
      persist: true,
    },
)